import React, { forwardRef, type MouseEvent } from "react";
import type { TextFieldProps } from "@mui/material";
import { BaseInput } from "src/components/BaseInput/BaseInput.tsx";
import { BaseInputAdornment } from "src/components/BaseInput/BaseInputAdornment.tsx";
import { composeRefs } from "@exonn/hooks";
import { css } from "@emotion/react";

export type PickerTextFieldProps = TextFieldProps & {
  onCalendarClick?: (e: MouseEvent<HTMLDivElement>) => void;
  onClearClick?: (e: MouseEvent<HTMLDivElement>) => void;
};

export const PickerTextField = forwardRef(
  (props: PickerTextFieldProps, ref) => {
    const {
      InputProps,
      onCalendarClick,
      onChange,
      onClearClick,
      value,
      className,
      onClick,
      onBlur,
      onFocus,
      onKeyUp,
      inputRef,
      error,
      disabled,
      placeholder,
      defaultValue,
      style,
      inputProps,
      inputProps: { onKeyDown, onPaste, style: inputStyle, inputMode } = {},
    } = props;

    return (
      <div style={style} css={rootStyles}>
        <BaseInput
          startAdornment={
            <BaseInputAdornment onClick={onCalendarClick} isAction={true}>
              <i className={"icon-15-calendar"} />
            </BaseInputAdornment>
          }
          endAdornment={
            value ? (
              <BaseInputAdornment onClick={onClearClick} isAction={true}>
                <i className="icon-15-clear_x" />
              </BaseInputAdornment>
            ) : undefined
          }
          style={inputStyle}
          css={inputStyles}
          className={className}
          hasError={error}
          ref={composeRefs(inputProps?.ref, InputProps?.ref, inputRef)}
          // @ts-ignore
          value={value}
          inputProps={{
            style: underlyingInputStyle,
          }}
          // @ts-ignore
          defaultValue={defaultValue}
          // @ts-ignore
          onChange={onChange}
          onKeyDown={onKeyDown}
          onKeyUp={onKeyUp}
          onPaste={onPaste}
          inputMode={inputMode}
          onFocus={onFocus}
          onBlur={onBlur}
          onClick={onClick}
          disabled={disabled}
          placeholder={placeholder}
        />
      </div>
    );
  },
);

const underlyingInputStyle = {
  paddingRight: 5,
};

const inputStyles = () => css`
  width: 100%;
  height: 100%;
`;

const rootStyles = css`
  position: relative;
  display: inline-block;
  width: 100%;
`;
